<template>
    <div class="nav_menu">
        <div class="grid-x align-center">
            <div class="cell small-12">
                <div class="nav_menu--inner">
                    <section class="nav_menu--section">
                        <h2 class="nav_menu--section--title"><strong>Highlight</strong></h2>
                        <ul class="grid-x grid--padding align-center">
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/discover#pickup" title="人気のプロジェクト" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>人気のプロジェクト</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/categories/All" title="新着プロジェクト" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>新着プロジェクト</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/categories/All/will_finish_soon" title="終了間近のプロジェクト" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>終了間近のプロジェクト</a>
                            </li>
                        </ul>
                    </section>

                    <section class="nav_menu--section">
                        <h2 class="nav_menu--section--title"><strong>Feature</strong></h2>
                        <ul class="grid-x grid--padding align-center">
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/discover" title="カテゴリーから探す" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>カテゴリーから探す</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/discover/tags" title="タグから探す" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>タグから探す</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/discover/curators_list" title="キュレーターから探す" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>キュレーターから探す</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/features" title="特集から探す" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>特集から探す</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/project_updates" title="最新進捗報告から探す" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>最新進捗報告から探す</a>
                            </li>
                        </ul>
                    </section>

                    <section class="nav_menu--section">
                        <h2 class="nav_menu--section--title"><strong>Legendary</strong></h2>
                        <ul class="grid-x grid--padding align-center">
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/categories/All/completed" title="最新達成プロジェクト" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>最新達成プロジェクト</a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://motion-gallery.net/categories/All/sort_by_amount" title="調達額が大きいプロジェクト" class="nav_menu--link"><svg class="icon icon-chevron"><use xlink:href="#icon-chevron" /></svg>調達額が大きいプロジェクト</a>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavMenu',
    data: () => ({
    })
}
</script>
